module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-bin-accad6d89d7d985c9dabdf5933f4487f.png";